import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";
import localeText from "../../../../../locale";

export const PERIODS = {
  ALL: "all",
  LAST_30: "last30",
  LAST_7: "last7",
  CUSTOM: "custom",
};

const toApiDate = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

const daysAgo = (days) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
};

// Mesmo formato de filtro que o endpoint de dashboard espera no admin clássico
export const buildDashboardFilter = (period, range) => {
  switch (period) {
    case PERIODS.LAST_30:
      return { dateBegin: toApiDate(daysAgo(30)), dateEnd: toApiDate(new Date()), filter: true };
    case PERIODS.LAST_7:
      return { dateBegin: toApiDate(daysAgo(7)), dateEnd: toApiDate(new Date()), filter: true };
    case PERIODS.CUSTOM:
      return { dateBegin: toApiDate(range[0]), dateEnd: toApiDate(range[1]), filter: true };
    default:
      return { dateBegin: "2000-01-01", dateEnd: "", filter: false };
  }
};

const PeriodFilter = ({ period, range, onChange }) => {
  const options = [
    { value: PERIODS.ALL, label: localeText("all") },
    { value: PERIODS.LAST_30, label: `30 ${localeText("days")}` },
    { value: PERIODS.LAST_7, label: `7 ${localeText("days")}` },
  ];

  return (
    <div className="admin-home-period">
      <div className="admin-home-period__segmented" role="group" aria-label={localeText("filters")}>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            className={classNames("admin-home-period__option", {
              "admin-home-period__option--active": period === option.value,
            })}
            aria-pressed={period === option.value}
            onClick={() => onChange(option.value, null)}
          >
            {option.label}
          </button>
        ))}
      </div>
      <Calendar
        value={period === PERIODS.CUSTOM ? range : null}
        onChange={(e) => {
          // Só filtra quando as duas datas do intervalo foram escolhidas
          if (e.value?.[0] && e.value?.[1]) onChange(PERIODS.CUSTOM, e.value);
        }}
        selectionMode="range"
        readOnlyInput
        showIcon
        maxDate={new Date()}
        dateFormat="dd/mm/yy"
        placeholder={localeText("adminHomeCustomPeriod")}
        className={classNames("admin-home-period__calendar", {
          "admin-home-period__calendar--active": period === PERIODS.CUSTOM,
        })}
      />
    </div>
  );
};

export default PeriodFilter;
